import { MaskLine } from "@/components/Reveal";

export const PageHeader = ({ eyebrow, title, subtitle }) => (
  <section className="relative pt-40 pb-16 max-w-[1400px] mx-auto px-6 lg:px-10">
    <p className="font-mono-j text-xs tracking-[0.25em] uppercase text-cyan-400 mb-6">{eyebrow}</p>
    <h1 className="font-display font-black tracking-tighter text-white text-[13vw] sm:text-7xl lg:text-8xl leading-[0.9]">
      {title.split(" ").map((w, i) => (
        <MaskLine key={i} delay={0.1 + i * 0.08} className="inline-block mr-4">{w}</MaskLine>
      ))}
    </h1>
    {subtitle && <p className="mt-8 max-w-2xl text-lg text-zinc-400 leading-relaxed">{subtitle}</p>}
  </section>
);
